import { createContext } from "react";
import { IAuthState, IAuthContext } from "../interfaces-and-types";

export const loggedOutAuthState: IAuthState = {
  // authentication
  is_logged_in: false,
  app_rehydration_completed: false,
  api_key: null, // for API keys, remove after creating separate app for hostedlinks
  session_id: null,
  checkout_session_id: null,
  token: null,

  // onboarding
  is_onboarding_step1_completed: false,
  is_onboarding_step2_completed: false,
  is_onboarding_step3_completed: false,
  is_onboarding_step4_completed: false,
  is_onboarding_step5_completed: false,

  // multi-tenancy & authorization
  active_tenant_id: "",
  staff_departments: [],

  // user profile
  user: null,
  user_settings: {
    show_balance: false,
    dark_mode_setting: "auto",
    hide_account_confirmation_nagger: false,
    allow_notifications: true,
    allow_newsletter_email_notifications: true,
    allow_newsletter_push_notifications: true,
  },
};

export const AuthContext = createContext<IAuthContext>({
  ...loggedOutAuthState,
  signIn: () => {},
  signOut: () => {},

  setAuthenticationState: () => {},
  setToken: () => {},
  setApiKey: () => {},
  setStaffDepartments: () => {},
  setActiveTenantId: () => {},
  setCheckoutSessionId: () => {},
  setUser: () => {},
  setUserSettings: () => {},
});
